import { render, staticRenderFns } from "./PageABCBookReader.vue?vue&type=template&id=63d17838&scoped=true&"
import script from "./PageABCBookReader.vue?vue&type=script&lang=js&"
export * from "./PageABCBookReader.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookReader.vue?vue&type=style&index=0&id=63d17838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d17838",
  null
  
)

export default component.exports